<template>
  <div id="basic">
    <div class="banner_bar">
      <h3>门店标签信息</h3>
      <el-form>
        <div class="bottom_center">
          <el-button
            type="primary"
            class="vubutton"
            :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
            @click="onSubmit"
          >+新建</el-button>
        </div>
        <div style="display:flex"  v-if="platform !== '1'">
          <el-form-item label="请选择门店" style="margin-right:20px">
            <el-select v-model="formInline.id" placeholder="请选择" @change="getTableData()">
              <el-option
                v-for="index in typeDate"
                v-bind:key="index.id"
                :label="index.name"
                :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="外卖堂食">
            <el-select
              v-model="formInline.category_type"
              placeholder="请选择"
              @change="getTableData()"
            >
              <el-option label="堂食" :value="1"></el-option>
              <el-option label="外卖" :value="2"></el-option>
            </el-select>
          </el-form-item>-->
        </div>
      </el-form>

      <el-table
        :fit="false"
        border
        :data="tableData"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="标签" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="简介" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.intro }}</span>
          </template>
        </el-table-column>
        <el-table-column label="图片" width="180">
          <template slot-scope="scope">
            <img :src="scope.row.image" style="width:50px;height:50px" />
          </template>
        </el-table-column>

        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button size="mini" @click="getEdit(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="pageSize"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog title="标签信息" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="标签" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>

        <el-form-item label="简介" :label-width="formLabelWidth">
          <el-input v-model="form.intro" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="属性值" v-if="form.getEdit||putStatus" :label-width="formLabelWidth">
          <el-tag
            closable
            v-for="tag in form.dish_attr_values"
            :key="tag.id"
            @click="setPutLabelValue(tag)"
            @close="deleteLabelValue(tag)"
            style="margin-right:5px"
          >{{tag.value}}:{{tag.intro}}</el-tag>
          <el-button size="mini" @click="setLabelValue">新增</el-button>
        </el-form-item>
        <el-form-item label="图片" :label-width="formLabelWidth">
          <el-upload
            :action="'https://upload-z2.qiniup.com'"
            list-type="picture-card"
            :auto-upload="true"
            :file-list="fileList"
            :on-success="topSuccess"
            :on-error="topSuccess"
            :before-upload="QiniuToken"
            :data="QiniuData"
            :limit="1"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  v-if="!form.getEdit"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  v-if="!form.getEdit"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="创建时间" :label-width="formLabelWidth" v-if="form.getEdit">
          <el-input v-model="form.created_at" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" :label-width="formLabelWidth" v-if="form.getEdit">
          <el-input v-model="form.updated_at" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="店铺编号" :label-width="formLabelWidth" v-if="form.getEdit">
          <el-input v-model="form.shop_id" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noStatus()">取 消</el-button>
        <el-button type="primary" @click="statusStore()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="属性信息" :visible.sync="dialogFormVisibles">
      <el-form :model="form">
        <el-form-item label="属性" :label-width="formLabelWidth">
          <el-input v-model="labelValue.value" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
        <el-form-item label="简介" :label-width="formLabelWidth">
          <el-input v-model="labelValue.intro" autocomplete="off" :disabled="form.getEdit"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibles=false">取 消</el-button>
        <el-button type="primary" @click="testNew">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';
export default {
  data() {
    return {
      platform: '',
      tableData: [],
      typeDate: [],
      datalist: [],
      parentid: null,
      formInline: {
        id: '',
      },
      total: 0,
      page_no: 0,
      dialogFormVisible: false,
      form: {
        name: '',
      },
      formLabelWidth: '120px',
      putStatus: false,
      //属性值开关
      dialogFormVisibles: false,
      //属性值
      labelValue: {
        value: '',
        intro: '',
      },
      testLabelValue: true,
      //七牛
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',

      QiniuData: {
        // key: '', //图片名字处理
        token: '', //七牛云token
      },
    };
  },
  methods: {
    setLabelValue() {
      this.labelValue = {
        value: '',
        intro: '',
      };
      this.testLabelValue = true;
      this.dialogFormVisibles = true;
    },
    setPutLabelValue(index) {
      this.labelValue = index;
      this.testLabelValue = false;
      this.dialogFormVisibles = true;
    },
    testNew() {
      if (this.testLabelValue) {
        this.postLabelValue();
      } else {
        this.putLabelValue();
      }
    },
    deleteLabelValue(index) {
      this.$confirm('此操作将删除标签属性, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_dish_raw_platform_create
        } else {
          baseUrl = this.$userList.user_dish_raw_create
        }
        const url = baseUrl + '/' + index.id;
        this.$http.delete(url).then(res => {
          if (res.code === 200) {
            this.handleEdit({}, this.form);
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除标签失败');
          }
        });
      });
    },
    testData(data) {
      let test = true;
      for (let index in data) {
        if ((!data[index] && data[index] !== 0) || data[index] === null) {
          test = false;
        }
      }
      return test;
    },
    postLabelValue() {
      const data = {
        value: this.labelValue.value,
        intro: this.labelValue.intro,
        dish_attr_id: this.form.id,
        version: 1,
      };
      if (!this.testData(data)) {
        this.$alert('标签属性不能为空');
        return;
      }

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_attr_value_platform
      } else {
        baseUrl = this.$userList.user_dish_attr_value
      }

      this.$http.post(baseUrl, data).then(res => {
        if (res.code === 200) {
          this.handleEdit({}, this.form);
          this.dialogFormVisibles = false;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    putLabelValue() {
      const data = {
        value: this.labelValue.value,
        intro: this.labelValue.intro,
        dish_attr_id: this.form.id,
        version: 1,
        id: this.labelValue.id,
      };

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_attr_value_platform
      } else {
        baseUrl = this.$userList.user_dish_attr_value
      }
      this.$http.put(baseUrl, data).then(res => {
        if (res.code === 200) {
          this.handleEdit({}, this.form);
          this.dialogFormVisibles = false;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    pageSize(index) {
      this.page_no = index;
      this.getTableData();
    },
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.id = res.data.items[0].id;
          this.getTableData();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    // 获取列表
    getTableData() {

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menudish_attr_list_platform
      } else {
        baseUrl = this.$userList.user_menudish_attr_list
      }


      const url =
          baseUrl +
        '/' +
        this.page_no +
        '/10?shop_id=' +
        this.formInline.id;


      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.items.map(items => {
            items.created_at = fecha.format(
              new Date(items.created_at),
              'yyyy-MM-dd HH:mm:ss'
            );
            items.updated_at = fecha.format(
              new Date(items.updated_at),
              'yyyy-MM-dd HH:mm:ss'
            );
            return items;
          });
          if (!this.tableData.length && this.page_no !== 0) {
            this.page_no = 0;
            this.getTableData();
          }
          this.total = res.data.count;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //详细信息
    getEdit(index, row) {
      // this.putStatus = true;
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menudish_attr_platform
      } else {
        baseUrl = this.$userList.user_menudish_attr
      }

      const url = baseUrl + '/' + row.id;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          res.data.getEdit = true;
          res.data.created_at = fecha.format(
            new Date(res.data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.updated_at = fecha.format(
            new Date(res.data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          this.form = res.data;
          this.fileList = [{ url: res.data.image }];
          this.dialogFormVisible = true;
          this.putStatus = true;
          return;
        }
        if (res.code !== 200) {
          this.$alert('获取详细信息失败');
        }
      });
      console.log(index, row);
    },
    //打开编辑弹窗
    handleEdit(index, row) {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menudish_attr_platform
      } else {
        baseUrl = this.$userList.user_menudish_attr
      }
      const url = baseUrl + '/' + row.id;

      this.$http.get(url).then(res => {
        if (res.code === 200) {
          res.data.created_at = fecha.format(
            new Date(res.data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.updated_at = fecha.format(
            new Date(res.data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          this.form = res.data;
          this.fileList = [{ url: res.data.image }];
          this.dialogFormVisible = true;
          this.putStatus = true;
          return;
        }
        if (res.code !== 200) {
          this.$alert('获取详细信息失败');
        }
      });
      console.log(index, row);
    },
    //删除
    handleDelete(index, row) {
      console.log(index, row);
      this.$confirm('此操作将删除菜品, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_menudish_attr_platform
        } else {
          baseUrl = this.$userList.user_menudish_attr
        }
        const url = baseUrl + '/' + row.id;

        this.$http.delete(url).then(res => {
          if (res.code === 200) {
            this.getTableData();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除标签失败');
          }
        });
      });
    },
    // 取消
    noStatus() {
      this.dialogFormVisible = false;
      if (this.form.getEdit || !this.putStatus) {
        return;
      }
    },
    setForm() {
      this.form = {
        name: '',
      };
      this.fileList = [];
    },
    onSubmit() {
      this.dialogFormVisible = true;
      this.putStatus = false;
      this.setForm();
    },
    statusStore() {
      if (this.form.getEdit) {
        this.dialogFormVisible = false;
        return;
      }
      if (!this.putStatus) {
        this.setStore();
      } else {
        this.putDtore();
      }
    },
    setStore() {
      console.log(this.form);

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menudish_attr_platform
      } else {
        baseUrl = this.$userList.user_menudish_attr
      }
      const datas = {
        name: this.form.name,
        intro: this.form.intro,
        image: (this.fileList.length && this.fileList[0].url) || '',
        dish_attr_type:1,
        shop_id: this.formInline.id,
      };
      if (!this.testData(datas)) {
        this.$alert('标签信息不能为空');
        return;
      }
      this.$http.post(baseUrl, datas).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('新增标签失败');
        }
        console.log(res);
      });
    },
    putDtore() {
      const data = {
        id: this.form.id,
        name: this.form.name,
        intro: this.form.intro,
        image: (this.fileList.length && this.fileList[0].url) || '',
        dish_attr_type:1,
        shop_id: this.formInline.id,
      };
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menudish_attr_platform
      } else {
        baseUrl = this.$userList.user_menudish_attr
      }

      this.$http.put(baseUrl, data).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('修改标签失败');
        }
      });
    },
    // 七牛
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    topSuccess(event, file, fileList) {
      console.log(fileList);
      this.fileList = fileList.map(item => {
        if (item.response) {
          item.name = item.response.hash;
          item.url = this.QiniuData.url_prefix + '/' + item.response.hash;
        }
        return item;
      });
    },
    async QiniuToken() {
      const url = this.$userList.user_status_qiniutoken_dish;
      const data = await this.$http.get(url).then(res => {
        return res;
      });
      if (data.code === 200 && data.data.up_token) {
        this.QiniuData.token = data.data.up_token;
        this.QiniuData.url_prefix = data.data.url_prefix;
        return true;
      } else {
        return false;
      }
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(item => {
        if (item.name !== file.name) {
          return item;
        }
      });
      console.log(file);
    },
    // 新增属性值
  },
  created() {
    let platform = this.$route.query.platform
    console.log("platform is :", platform)
    this.platform = platform
    this.$root.setheadName();
    this.getType();
  },
};
</script>

<style scoped>
#basic {
  width: 100%;
  height: auto;
  position: relative;
}
.banner_bar {
  width: 100%;
  height: auto;
  background: #fff;
  min-height: 800px;
  box-sizing: border-box;
  padding: 20px;
}
.top_button {
  width: 100%;
  min-height: 300px;
  display: flex;
}
.button_a {
  width: 300px;
  height: auto;
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-right: 50px;
  margin-bottom: 50px;
}
.button_top {
  width: 100%;
  height: 64px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
}
.button_push {
  width: 63px;
  height: 32px;
  background: #1890ff;
  color: #fff;
  text-align: center;
  line-height: 32px;
  border-radius: 10px;
}
.banner_ul {
  width: 100%;
  height: auto;
}
.banner_ul li {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
  line-height: 40px;
}
.li_icon i {
  margin-right: 10px;
  width: 16rpx !important;
  height: 16rpx !important;
}
.colorli {
  background: rgba(127, 125, 243, 0.3);
}
.bottoms {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  height: 100%;
  height: 20px;
}
</style>
